import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Table, Badge, Button, Modal, Form, Card } from "react-bootstrap";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL } from "./../config";
import CadastrarResumoChamada from "./CadastroResumo.jsx";
import RegistrosAula from './RegistrosAula.jsx'

const DURACOES_AULA = [
  { value: "0.75", label: "45min" },
  { value: "1.0", label: "1h" },
  { value: "1.5", label: "1h30" },
  { value: "2.0", label: "2h" },
];

const getBadgeVariant = (status) => {
  switch (status) {
    case "Presente":
      return "success";
    case "Ausente":
      return "danger";
    case "Justificado":
      return "warning";
    default:
      return "secondary";
  }
};

const formatDuracao = (value) => {
  const duracao = Number(value || 0);
  if (!Number.isFinite(duracao) || duracao <= 0) return "";
  const totalMinutos = Math.round(duracao * 60);
  const horas = Math.floor(totalMinutos / 60);
  const minutos = totalMinutos % 60;
  if (!horas) return `${minutos}min`;
  return `${horas}h${minutos ? String(minutos).padStart(2, "0") : ""}`;
};

const HistoricoChamadas = ({ turmaId, historico, onUpdateStatus, alunos, atualizarHistorico }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [resumosPorData, setResumosPorData] = useState({});
  const [itemsPerPage] = useState(10);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingStatusUpdate, setPendingStatusUpdate] = useState(null);
  const [showDeleteChamadaModal, setShowDeleteChamadaModal] = useState(false);
  const [chamadaParaExcluir, setChamadaParaExcluir] = useState(null);
  const [showResumoForm, setShowResumoForm] = useState(false);
  const [selectedChamadaId, setSelectedChamadaId] = useState(null);
  const [selectedChamadaDate, setSelectedChamadaDate] = useState(null);
  const [atualizarResumos, setAtualizarResumos] = useState(false);
  const [formData, setFormData] = useState({
    alunoId: "",
    data: dayjs().format("YYYY-MM-DD"),
    hora: dayjs().format("HH:mm"),
    status: "Presente",
    duracao: "1.0",
  });
  const [formDataLote, setFormDataLote] = useState({
    data: dayjs().format("YYYY-MM-DD"),
    hora: dayjs().format("HH:mm"),
    status: "Presente",
    duracao: "1.0",
  });
  const [showChamadaLote, setShowChamadaLote] = useState(false);
  const [salvandoChamada, setSalvandoChamada] = useState(false);
  const [salvandoLote, setSalvandoLote] = useState(false);
  const isMobile = window.innerWidth <= 768;

  const confirmStatusUpdate = (chamadaId, status) => {
    setPendingStatusUpdate({ chamadaId, status });
    setShowConfirmModal(true);
  };


  const handleAtualizarResumos = () => {
    setAtualizarResumos((prev) => !prev);
  };

  const handleAbrirModalExcluirChamada = (chamada) => {
    setChamadaParaExcluir(chamada);
    setShowDeleteChamadaModal(true);
  };

  const handleFecharModalExcluirChamada = () => {
    setShowDeleteChamadaModal(false);
    setChamadaParaExcluir(null);
  };

  const handleDeleteChamada = async () => {
    if (!chamadaParaExcluir?.cp_ch_id) return;

    try {
      await axios.delete(`${API_BASE_URL}/chamadas/${chamadaParaExcluir.cp_ch_id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      toast.success("Chamada deletada com sucesso.");
      atualizarHistorico();
    } catch (error) {
      console.error("Erro ao deletar chamada:", error);
      toast.error("Erro ao deletar chamada. Tente novamente mais tarde.");
    } finally {
      handleFecharModalExcluirChamada();
    }
  };

  const handleOpenResumoForm = (chamada) => {
    if (chamada) {
      setSelectedChamadaId(chamada.cp_ch_id);
      const dataFront = dayjs(chamada.cp_ch_data);
      setSelectedChamadaDate(dataFront.isValid() ? dataFront.format("DD-MM-YYYY") : chamada.cp_ch_data);
    }
    setShowResumoForm(true);
  };

  const handleConfirmStatusUpdate = () => {
    if (pendingStatusUpdate) {
      onUpdateStatus(pendingStatusUpdate.chamadaId, pendingStatusUpdate.status);
      setPendingStatusUpdate(null);
      setShowConfirmModal(false);
    } else {
      toast.error("Erro ao confirmar a atualização do status.");
    }
  };

  const totalPaginas = Math.ceil(historico.length / itemsPerPage);
  const currentItems = historico.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const paginasVisiveis = [];
  for (let i = Math.max(1, currentPage - 2); i <= Math.min(totalPaginas, currentPage + 2); i++) {
    paginasVisiveis.push(i);
  }

  const totalDuracaoPorAluno = historico.reduce((acc, chamada) => {
    if (chamada.cp_ch_status !== "Presente") return acc;

    const alunoKey = chamada.cp_nome_aluno || chamada.cp_ch_aluno_id || "sem-aluno";
    acc[alunoKey] = (acc[alunoKey] || 0) + Number(chamada.cp_ch_duracao || 0);
    return acc;
  }, {});

  const getTituloResumoPorData = (data) => {
    const resumo = resumosPorData[data]?.find((item) => item.cp_res_aula);
    return resumo?.cp_res_aula || "";
  };

  // useEffect(() => {
  //   if (!turmaId) {
  //     console.error("turmaId está indefinido");
  //     return;
  //   }
  //   axios
  //     .get(`${API_BASE_URL}/turmas/${turmaId}/alunos`)
  //     .then((response) => {
  //       setUsuariosDisponiveis(response.data);
  //       if (response.data.length === 1) {
  //         setFormData((prev) => ({
  //           ...prev,
  //           alunoId: response.data[0].cp_id,
  //         }));
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Erro ao buscar alunos:", error);
  //       toast.error("Erro ao buscar alunos. Tente novamente.");
  //     });
  // }, [turmaId]);


  useEffect(() => {
    // if (turmaId) {
    //   atualizarResumos();
    //   atualizarHistorico();
    // }
    setCurrentPage(1);
  }, [turmaId]);

  useEffect(() => {
    const fetchResumosHistorico = async () => {
      if (!turmaId) {
        setResumosPorData({});
        return;
      }

      try {
        const response = await axios.get(`${API_BASE_URL}/resumos/${turmaId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });

        const agrupados = (Array.isArray(response.data) ? response.data : []).reduce((acc, resumo) => {
          const data = resumo.cp_res_data;
          if (!acc[data]) acc[data] = [];
          acc[data].push(resumo);
          return acc;
        }, {});

        setResumosPorData(agrupados);
      } catch (error) {
        console.error("Erro ao buscar títulos dos resumos:", error);
      }
    };

    fetchResumosHistorico();
  }, [turmaId, atualizarResumos]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (alunos.length === 1 && formData.alunoId !== alunos[0].cp_id) {
      setFormData((prev) => ({ ...prev, alunoId: alunos[0].cp_id }));
    }
  }, [alunos, formData.alunoId]);


  const handleCadastrarChamada = async () => {
    if (salvandoChamada) return;
    const { alunoId, data, hora, status, duracao } = formData;
    if (!alunoId || !data || !hora || !status || !turmaId) {
      toast.error("Preencha todos os campos obrigatórios.");
      return;
    }
    setSalvandoChamada(true);
    try {
      await axios.post(`${API_BASE_URL}/chamadas`, { turmaId, alunoId, data, hora, status, duracao }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      toast.success("Chamada cadastrada com sucesso!");
      setFormData({ alunoId: "", data: dayjs().format("YYYY-MM-DD"), hora: dayjs().format("HH:mm"), status: "Presente", duracao: "1.0" });
      atualizarHistorico();
    } catch (error) {
      console.error("Erro ao cadastrar chamada:", error);
      toast.error("Erro ao cadastrar chamada. Tente novamente.");
    } finally {
      setSalvandoChamada(false);
    }
  };

  const handleCadastrarChamadaLote = async () => {
    if (salvandoLote) return;
    const { data, hora, status, duracao } = formDataLote;
    if (!data || !hora || !status || !turmaId) {
      toast.error("Preencha todos os campos obrigatórios.");
      return;
    }
    
    if (alunos.length === 0) {
      toast.error("Nenhum aluno encontrado nesta turma.");
      return;
    }

    setSalvandoLote(true);
    try {
      const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
      await axios.post(`${API_BASE_URL}/chamadas/lote`, {
        turmaId,
        alunoIds: alunos.map((aluno) => aluno.cp_id),
        data,
        hora,
        status,
        duracao
      }, { headers });

      toast.success(`Chamada cadastrada para todos os ${alunos.length} alunos!`);
      setFormDataLote({ data: dayjs().format("YYYY-MM-DD"), hora: dayjs().format("HH:mm"), status: "Presente", duracao: "1.0" });
      setShowChamadaLote(false);
      atualizarHistorico();
    } catch (error) {
      console.error("Erro ao cadastrar chamadas em lote:", error);
      toast.error("Nenhuma chamada foi alterada. Tente novamente.");
    } finally {
      setSalvandoLote(false);
    }
  };

  const handleInputChangeLote = (e) => {
    const { name, value } = e.target;
    setFormDataLote((prev) => ({ ...prev, [name]: value }));
  };

  // const atualizarResumos = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/resumos/${turmaId}`);
  //     const resumos = response.data;

  //     const agrupados = resumos.reduce((acc, resumo) => {
  //       const data = resumo.cp_res_data;
  //       if (!acc[data]) acc[data] = [];
  //       acc[data].push(resumo);
  //       return acc;
  //     }, {});

  //     console.log("Etapa 2: Atualizando resumosPorData no pai:", agrupados);
  //     setResumosPorData(agrupados);
  //   } catch (error) {
  //     console.error("Erro ao atualizar resumos no pai:", error);
  //     toast.error("Erro ao atualizar resumos. Tente novamente.");
  //   }
  // };



  return (
    <div className="d-flex flex-column flex-lg-row">
      {/* Coluna da Esquerda: Formulário de Chamada e Registros */}
      <div className="d-flex flex-column border-end border-light-subtle bg-theme-surface chamada-registro-col" style={{ width: isMobile ? '100%' : '380px', minWidth: isMobile ? '100%' : '350px' }}>
          <div className="p-3 border-bottom bg-theme-secondary-subtle">
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                        <h5 className="fw-bold mb-0 text-theme-primary d-flex align-items-center gap-2">
                            <Icon icon="mdi:clipboard-check-outline" className="text-primary" />
                            Nova Chamada
                        </h5>
                        <div className="d-flex bg-theme-surface rounded-pill p-1 border shadow-sm">
                        <button
                            className={`btn btn-sm rounded-pill px-3 fw-semibold ${!showChamadaLote ? 'btn-primary text-white shadow-sm' : 'text-secondary border-0 btn-toggle-inactive'}`}
                            onClick={() => setShowChamadaLote(false)}
                            style={{ transition: "all 0.2s" }}
                        >
                            Individual
                        </button>
                        <button
                            className={`btn btn-sm rounded-pill px-3 fw-semibold ${showChamadaLote ? 'btn-primary text-white shadow-sm' : 'text-secondary border-0 btn-toggle-inactive'}`}
                            onClick={() => setShowChamadaLote(true)}
                            style={{ transition: "all 0.2s" }}
                        >
                            Em Lote
                        </button>
                        </div>
                </div>
                <p className="text-muted small mb-0">Preencha os dados abaixo para registrar a presença.</p>
          </div>
          
          <div className="p-3">
                {!showChamadaLote ? (
                // Formulário individual
                <Form className="d-flex flex-column gap-3">
                    <Form.Group controlId="alunoId">
                        <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Aluno</Form.Label>
                        {alunos.length === 1 ? (
                            <Form.Control
                                type="text"
                                value={alunos[0].cp_nome}
                                readOnly
                                className="fw-semibold form-control-card"
                                onFocus={() =>
                                    setFormData((prev) => ({ ...prev, alunoId: alunos[0].cp_id }))
                                }
                            />
                        ) : (
                            <Form.Select
                                name="alunoId"
                                value={formData.alunoId}
                                onChange={handleInputChange}
                                className="form-select"
                            >
                                <option value="">Selecione um aluno</option>
                                {alunos.map((aluno) => (
                                    <option key={aluno.cp_id} value={aluno.cp_id}>
                                        {aluno.cp_nome}
                                    </option>
                                ))}
                            </Form.Select>
                        )}
                    </Form.Group>

                    <div className="row g-2">
                        <div className="col-6">
                            <Form.Group controlId="data">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Data</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="data"
                                    value={formData.data}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-6">
                            <Form.Group controlId="hora">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Hora</Form.Label>
                                <Form.Control
                                    type="time"
                                    name="hora"
                                    value={formData.hora}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="col-6">
                                <Form.Group controlId="status">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Status</Form.Label>
                                <Form.Select
                                    name="status"
                                    value={formData.status}
                                    onChange={handleInputChange}
                                >
                                    <option value="Presente">Presente</option>
                                    <option value="Ausente">Ausente</option>
                                    <option value="Justificado">Justificado</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="col-6">
                            <Form.Group controlId="duracao">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Duração</Form.Label>
                                <Form.Select
                                    name="duracao"
                                    value={formData.duracao}
                                    onChange={handleInputChange}
                                >
                                    {DURACOES_AULA.map(({ value, label }) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>

                    <Button variant="primary" onClick={handleCadastrarChamada} disabled={salvandoChamada} className="w-100 mt-2 py-2 fw-bold shadow-sm">
                        <Icon icon={salvandoChamada ? "mdi:loading" : "mdi:check"} className="me-2" />
                        {salvandoChamada ? "Registrando..." : "Registrar Presença"}
                    </Button>
                </Form>
            ) : (
                // Formulário em lote
                <Form className="d-flex flex-column gap-3">
                    <div className="alert alert-info border-0 small mb-0 rounded-3 d-flex align-items-center gap-2">
                        <Icon icon="mdi:information-circle" className="fs-5 flex-shrink-0" />
                        <div>
                            Registro para <strong>{alunos.length} alunos</strong>.
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="col-6">
                            <Form.Group controlId="dataLote">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Data</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="data"
                                    value={formDataLote.data}
                                    onChange={handleInputChangeLote}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-6">
                            <Form.Group controlId="horaLote">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Hora</Form.Label>
                                <Form.Control
                                    type="time"
                                    name="hora"
                                    value={formDataLote.hora}
                                    onChange={handleInputChangeLote}
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="col-6">
                                <Form.Group controlId="statusLote">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Status</Form.Label>
                                <Form.Select
                                    name="status"
                                    value={formDataLote.status}
                                    onChange={handleInputChangeLote}
                                >
                                    <option value="Presente">Presente</option>
                                    <option value="Ausente">Ausente</option>
                                    <option value="Justificado">Justificado</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="col-6">
                            <Form.Group controlId="duracaoLote">
                                <Form.Label className="fw-bold small text-uppercase text-muted mb-1">Duração</Form.Label>
                                <Form.Select
                                    name="duracao"
                                    value={formDataLote.duracao}
                                    onChange={handleInputChangeLote}
                                >
                                    {DURACOES_AULA.map(({ value, label }) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>

                    <Button variant="primary" onClick={handleCadastrarChamadaLote} disabled={salvandoLote} className="w-100 mt-2 py-2 fw-bold shadow-sm">
                        <Icon icon={salvandoLote ? "mdi:loading" : "mdi:check-all"} className="me-2" />
                        {salvandoLote ? "Registrando..." : "Registrar Todos"}
                    </Button>
                </Form>
            )}

            <div className="mt-4 pt-3 border-top">
                <RegistrosAula
                    turmaId={turmaId}
                    chamadaId={selectedChamadaId}
                    onAtualizar={atualizarHistorico}
                    atualizarResumos={atualizarResumos}
                />
            </div>
          </div>
      </div>

      {/* Coluna da Direita: Tabela de Histórico */}
      <div className="flex-grow-1 d-flex flex-column bg-theme-surface">
            <div className="p-3 border-bottom d-flex justify-content-between align-items-center bg-theme-secondary-subtle">
                <div>
                    <h5 className="fw-bold mb-0 text-theme-primary d-flex align-items-center gap-2">
                        <Icon icon="mdi:history" className="text-primary" />
                        Histórico
                    </h5>
                    <p className="text-muted small mb-0">Últimos registros de presença.</p>
                </div>
            </div>
            
            <div className="d-flex flex-column">
                {currentItems.length > 0 ? (
                    currentItems.map((chamada) => {
                      const duracao = formatDuracao(chamada.cp_ch_duracao);
                      const totalDuracao = formatDuracao(totalDuracaoPorAluno[chamada.cp_nome_aluno]);
                      const tituloResumo = getTituloResumoPorData(chamada.cp_ch_data);

                      return (
                        <div key={chamada.cp_ch_id} className="p-3 border-bottom d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 historico-item transition-all">
                            {/* Info Block */}
                            <div className="d-flex flex-column justify-content-center mb-2 mb-md-0">
                                <span className="fw-bold fs-6 text-theme-primary">{chamada.cp_nome_aluno}</span>
                            </div>

                            <div className="historico-extra-info">
                                <div className="historico-duracao text-theme-primary">
                                    {duracao && <span>{duracao}</span>}
                                    {totalDuracao && <small>Total: {totalDuracao}</small>}
                                </div>
                                <div className="historico-titulo text-theme-primary" title={tituloResumo}>
                                    {tituloResumo}
                                </div>
                            </div>

                            {/* Status & Actions Block */}
                            <div className="d-flex flex-column align-items-md-end gap-2 w-100 w-md-auto">
                                {/* Date & Time - Top Right */}
                                <div className="d-flex align-items-center gap-3 text-muted small">
                                    <span className="d-flex align-items-center gap-1">
                                        <Icon icon="mdi:calendar" className="opacity-75" /> 
                                        {dayjs(chamada.cp_ch_data).format("DD/MM/YYYY")}
                                    </span>
                                    <span className="d-flex align-items-center gap-1">
                                        <Icon icon="mdi:clock-outline" className="opacity-75" /> 
                                        {chamada.cp_ch_hora?.substring(0, 5)}
                                    </span>
                                </div>

                                {/* Buttons & Badge */}
                                <div className="d-flex flex-wrap align-items-center justify-content-between justify-content-md-end gap-3 w-100 w-md-auto">
                                    <Badge 
                                        bg={getBadgeVariant(chamada.cp_ch_status)} 
                                        className="rounded-pill px-3 py-2 fw-normal"
                                    >
                                        {chamada.cp_ch_status}
                                    </Badge>

                                    <div className="d-flex gap-1">
                                        <Button variant="light" size="sm" className="btn-icon rounded-circle text-success bg-success-subtle border-0" onClick={() => confirmStatusUpdate(chamada.cp_ch_id, "Presente")} title="Presente">
                                            <Icon icon="mdi:check" />
                                        </Button>
                                        <Button variant="light" size="sm" className="btn-icon rounded-circle text-warning bg-warning-subtle border-0" onClick={() => confirmStatusUpdate(chamada.cp_ch_id, "Justificado")} title="Justificado">
                                            <Icon icon="mdi:alert-circle-outline" />
                                        </Button>
                                        <Button variant="light" size="sm" className="btn-icon rounded-circle text-danger bg-danger-subtle border-0" onClick={() => confirmStatusUpdate(chamada.cp_ch_id, "Ausente")} title="Ausente">
                                            <Icon icon="mdi:close" />
                                        </Button>
                                        <div className="vr mx-2 opacity-25"></div>
                                        <Button variant="light" size="sm" className="btn-icon rounded-circle chamada-resumo-action border-0" onClick={() => handleOpenResumoForm(chamada)} title="Resumo">
                                            <Icon icon="mdi:note-text-outline" />
                                        </Button>
                                        <Button variant="light" size="sm" className="btn-icon rounded-circle text-danger bg-danger-subtle border-0" onClick={() => handleAbrirModalExcluirChamada(chamada)} title="Excluir">
                                            <Icon icon="mingcute:delete-2-line" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                      );
                    })
                ) : (
                    <div className="text-center py-5 text-muted">
                        <div className="d-flex flex-column align-items-center">
                            <Icon icon="mdi:clipboard-text-off-outline" className="fs-1 mb-2 opacity-25" />
                            <p className="mb-0">Nenhum registro de chamada encontrado.</p>
                        </div>
                    </div>
                )}
            </div>
                    
                    {/* Paginação */}
                    {totalPaginas > 1 && (
                        <div className="d-flex align-items-center justify-content-between p-4 border-top chamadas-pagination">
                             <span className="text-label small">
                                 Página {currentPage} de {totalPaginas}
                             </span>
                             <ul className="pagination mb-0 gap-1">
                                 <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                     <button className="page-link rounded-circle border-0 d-flex align-items-center justify-content-center" style={{width: 32, height: 32}} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                                         <Icon icon="ep:arrow-left" />
                                     </button>
                                 </li>
                                 {paginasVisiveis.map(page => (
                                     <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                         <button 
                                             className={`page-link rounded-circle border-0 d-flex align-items-center justify-content-center ${currentPage === page ? 'bg-primary text-white shadow-sm' : ''}`} 
                                             style={{width: 32, height: 32}}
                                             onClick={() => setCurrentPage(page)}
                                         >
                                             {page}
                                         </button>
                                     </li>
                                 ))}
                                 <li className={`page-item ${currentPage === totalPaginas ? 'disabled' : ''}`}>
                                     <button className="page-link rounded-circle border-0 d-flex align-items-center justify-content-center" style={{width: 32, height: 32}} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPaginas))}>
                                         <Icon icon="ep:arrow-right" />
                                     </button>
                                 </li>
                             </ul>
                        </div>
                    )}
      </div>

      {/* Modal para Cadastro de Resumo */}
      <Modal 
        show={showResumoForm} 
        onHide={() => setShowResumoForm(false)} 
        centered 
        size="lg"
        contentClassName="border-0 shadow-lg"
        style={{ borderRadius: "16px" }}
      >
         <Modal.Header closeButton className="border-0 pb-0">
             <Modal.Title className="fw-bold">Resumo da Aula</Modal.Title>
         </Modal.Header>
         <Modal.Body className="p-0">
             <div className="p-3">
                <CadastrarResumoChamada
                    chamadaId={selectedChamadaId}
                    turmaId={turmaId}
                    setShowResumoForm={setShowResumoForm}
                    atualizarResumos={handleAtualizarResumos}
                    dataChamada={selectedChamadaDate}
                />
             </div>
         </Modal.Body>
      </Modal>

      
      {/* Modal de confirmação status */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered contentClassName="border-0 shadow-lg rounded-4">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">Confirmar Alteração</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4 text-center">
            <div className={`mb-3 mx-auto rounded-circle d-flex align-items-center justify-content-center bg-${getBadgeVariant(pendingStatusUpdate?.status)}-subtle text-${getBadgeVariant(pendingStatusUpdate?.status)}`} style={{width: 64, height: 64}}>
                <Icon icon="mdi:alert-circle-outline" width="32" />
            </div>
          <p className="mb-0">
              Deseja alterar o status para <strong className={`text-${getBadgeVariant(pendingStatusUpdate?.status)}`}>{pendingStatusUpdate?.status}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-4">
          <Button variant="light" onClick={() => setShowConfirmModal(false)} className="rounded-pill px-4">
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleConfirmStatusUpdate} className="rounded-pill px-4">
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteChamadaModal} onHide={handleFecharModalExcluirChamada} centered contentClassName="border-0 shadow-lg rounded-4">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4 text-center">
          <div className="mb-3 mx-auto rounded-circle d-flex align-items-center justify-content-center bg-danger-subtle text-danger" style={{width: 64, height: 64}}>
            <Icon icon="mdi:trash-can-outline" width="32" />
          </div>
          <p className="mb-0">
            Deseja excluir a chamada de <strong>{chamadaParaExcluir?.cp_nome_aluno}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-4">
          <Button variant="light" onClick={handleFecharModalExcluirChamada} className="rounded-pill px-4">
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDeleteChamada} className="rounded-pill px-4">
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HistoricoChamadas;
